export const visit = (vm, at) => {
at({ "nl": { "upgradePointTooltip": { "upgradePageLink_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, createElement( options, "Link", props, "Upgrade" ), " om deze actie uit te voeren." ); } } } });
};